import { useMicrophoneTest } from "../../../model/use-microphone-test";
import { AudioLevelMeter } from "./audio-level-meter";
import s from "../conference-settings-modal.module.scss";

export const MicrophoneDiagnostics = ({
  deviceId,
}) => {
  const {
    level,
    status,
    message,
    recordingUrl,
    audioElementRef,
    startRecording,
    stopRecording,
    togglePlayback,
    finishPlayback,
  } = useMicrophoneTest({
    deviceId,
  });

  const handleAction = () => {
    if (status === "recording") {
      stopRecording();
      return;
    }

    if (status === "playing") {
      togglePlayback();
      return;
    }

    startRecording();
  };

  const buttonLabel =
    status === "recording" || status === "playing" ? "Остановить" : "Проверить микрофон";

  return (
    <div className={s.deviceDiagnostics}>
      <div className={s.deviceTestRow}>
        <div className={s.audioActions}>
          <button
            type="button"
            className={s.audioButton}
            onClick={handleAction}
          >
            {buttonLabel}
          </button>
        </div>
        <div className={s.levelMeter}>
          <AudioLevelMeter
            level={level}
            status={
              status === "recording" || status === "playing"
                ? "active"
                : status === "error"
                  ? "error"
                  : "idle"
            }
            idleLabel={message}
            activeLabel={message}
            errorLabel={message}
          />
        </div>
      </div>
      <audio
        ref={audioElementRef}
        className={s.hiddenAudio}
        src={recordingUrl || undefined}
        onEnded={finishPlayback}
      />
    </div>
  );
};
